import mitt from "mitt";
import { ConfirmationModal, Snackbar } from "@/application/types";

const instance = mitt<{
  refreshModule: string;
  confirm: ConfirmationModal;
  snackbar: Snackbar;
  "cancel:request": string;
}>();

export default instance;
